import Request from './Request';
import Confirmation from './Confirmation';

const Default = {
  Request,
  Confirmation,
};

export default Default;
